export default "__VITE_ASSET__ZJrcNMrq__"